export const debugLinkedInQueryKeys = {
  all: ['debug', 'linkedin'] as const,
  accounts: () => [...debugLinkedInQueryKeys.all, 'accounts'] as const,
  threads: (accountId: string | null) =>
    [...debugLinkedInQueryKeys.all, 'threads', accountId] as const,
  messages: (threadId: string | null) =>
    [...debugLinkedInQueryKeys.all, 'messages', threadId] as const,
};
